import { render, staticRenderFns } from "./ChatHistoryItem.vue?vue&type=template&id=3d195928&scoped=true"
import script from "./ChatHistoryItem.vue?vue&type=script&lang=js"
export * from "./ChatHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./ChatHistoryItem.vue?vue&type=style&index=0&id=3d195928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d195928",
  null
  
)

export default component.exports